import { Pipe, PipeTransform } from '@angular/core';
import { CourseBundle } from 'lms-api';

@Pipe({
  name: 'bundleList'
})
export class bundleListPipe implements PipeTransform {

  transform(value: CourseBundle[], access: boolean, canPurchase: boolean): CourseBundle[] {
    if (!value) value = [];
    return value.filter(b => b.Access == access && b.CanPurchase == canPurchase);
  }

}
